import React, { Component } from 'react';
import { Platform, StyleSheet, TextInput, View } from 'react-native';

class SearchInput extends Component {

  constructor (props) {
    super(props);

    let {query} = this.props;
    if (!query) {
      query = '';
    }
    this.state = {
      query: query,
    };
  }

  componentDidMount () {
  }

  componentWillUnmount () {
  }

  componentWillReceiveProps (nextProps) {
    if (nextProps.query !== this.state.query) {
      this.setState({
        query: nextProps.query,
      });
    }
  }

  _updateQuery = (text) => {
    this.setState({
      query: text,
    });
    const {onUpdateQuery} = this.props;
    if (onUpdateQuery) {
      onUpdateQuery(text);
    }
  };

  _submit = () => {
    const {onSubmit} = this.props;
    if (onSubmit) {
      onSubmit();
    }
  };

  render () {
    const {placeholder} = this.props;
    const {query} = this.state;
    return (
      <View
        style={styles.header}>
        <View
          style={styles.search}>
          <View
            style={styles.searchBackground}/>
          <TextInput
            ref='queryTextInput'
            value={query}
            placeholder={placeholder}
            placeholderTextColor='#454c53bf'
            underlineColorAndroid='transparent'
            clearButtonMode='while-editing'
            autoCapitalize='none'
            returnKeyType='search'
            onChangeText={this._updateQuery}
            onSubmitEditing={this._submit}
            style={styles.searchTextInput}/>
        </View>
      </View>
    );
  }
}

const styles = StyleSheet.create({
  header: {
    flexDirection: 'row',
    alignItems: 'center',
    ...Platform.select({
      web: {
        height: 56,
      },
    }),
  },
  search: {
    flex: 1,
    flexDirection: 'row',
    alignItems: 'center',
  },
  searchBackground: {
    position: 'absolute',
    top: 0, left: 0, bottom: 0, right: 0,
    borderRadius: 18,
    borderWidth: 1,
    borderColor: '#e2d7ba',
    backgroundColor: '#ffffff',
  },
  searchTextInput: {
    flex: 1,
    height: 36,
    padding: 0,
    marginLeft: 12,
    marginRight: 12,
    color: '#51585e',
    fontSize: 17,
    fontWeight: '300',
    backgroundColor: 'transparent',
    zIndex: 1,
    ...Platform.select({
      web: {
        outline: 'transparent',
      },
    }),
  },
});

export default SearchInput;



// WEBPACK FOOTER //
// ./src/common/SearchInput.js